<template>
  <div id="cat" v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: 'شناسه همیار فروش' },
            { title: 'زمان ورود به وبسایت' },
            { title: 'لینک هدایت شده' },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 20%">
              {{ row.referralCode }}
            </td>
            <td style="width: 20%; direction: ltr">
              {{ row.visitedOn }}
            </td>
            <td style="width: 50%; direction: ltr">
              {{ row.url }}
            </td>
          </template>
        </data-grid>
        <div style="direction: ltr"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/WebsiteDataGrid";
import vSelect from "vue-select";
export default {
  components: {
    DataGrid,
    "v-select": vSelect,
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "api/ReferralVisitorsQuery",
      },
      gridSearchData: {
        promoterId: this.$route.params.id,
      },
    };
  },
};
</script>

<style></style>
